export const environment = {
  hmr: false,
  production: true,
  google_font_api_key: "AIzaSyDwaZW8Js8gEilkKGttJvB9M8DaBQc8R6Q",
  GAPI_CLIENT_ID:
    "867696806986-ltugtjho6n2l9obtrmkme3p95k971ose.apps.googleusercontent.com",
};
